import React, { useState, useEffect, useRef } from 'react'
import DataGridAlternativa from '../../../../components/DataGridAlternativa'
import { consultar } from '../../../../util/AcessoApi'
import { Alterar, Excluir, Visualizar, Imprimir, BtnAcao, Btn, Detalhes, AlteracaoStatusLote, EnviarLoteCoop, VisualizarArquivo, VisualizarErro, VisualizarRelacaoGuias } from '../../../../components/Acoes'
import { BotaoPadrao } from '../../../../components/Botoes'
import moment from 'moment';
import Dropdown, { DropdownTrigger, DropdownContent } from 'react-simple-dropdown';
import { getUsuario, getApi } from '../../../../util/Configuracoes'
import { ACOES } from '../../../../util/Enums'
import { get, excluir, salvar, validar } from '../../../../util/AcessoApi'
import { mostrarToast } from '../../../../components/Toasts'
import { mensagens, useWindowSize } from '../../../../util/Utilitarios.js'
import { InputPadrao, TextArea } from '../../../../components/Inputs'
import { InputLoteStatus } from '../../../../components/InputsAutoComplete'
import Yup from '../../../../util/Validacoes';
import { ModalCadastro, ModalDuasOpcoes } from '../../../../components/Modais'
import { Formik, Form } from "formik";
import { LoadRelatorio } from '../../../../components/Loading'
import { useHistory, Link } from 'react-router-dom'
import { OverlayTrigger, Tooltip, Popover } from 'react-bootstrap';



const ConsultaCliente = rProps => {
    const [data, setData] = useState([])
    const target = useRef(null)
    const [modalAlteracaoStatus, setModalAlteracaoStatus] = useState(false)
    const [itemTrocarStauts, setItemTrocarStatus] = useState({})
    const [showModalDetalhes, setShowModalDetalhes] = useState(false)
    const [itemDetalhes, setItemDetalhes] = useState([])
    const [width] = useWindowSize()
    const history = useHistory()


    // useEffect(_ => { consultar('/faturamento/lote', dados => setData(dados.sort((a, b) => b.id - a.id))) }, [rProps])

    const columns = React.useMemo(
        () => [{
            id: 'consulta-lote',
            columns: [
                {
                    Header: 'Código',
                    accessor: 'id',
                    ordenamento: {
                        tipo: 'numero',
                        ativo: true,
                        modo: 'desc',
                    }
                },
                {
                    Header: 'Prestador',
                    accessor: 'prestador',
                    ordenamento: {
                        tipo: 'texto'
                    },
                    filtro: {
                        tipo: 'prestador_conselho',
                        idColuna: 'pcpr_pres_id'
                    }
                },
                {
                    Header: 'Conselho Profissional',
                    accessor: 'conselho_profissional',
                    ordenamento: {
                        tipo: 'texto'
                    },
                    filtro: {
                        tipo: 'conselho_profissional',
                        idColuna: 'pcpr_conselho_profissional_id'
                    }
                },
                {
                    Header: 'Estado',
                    accessor: 'estado',
                    ordenamento: {
                        tipo: 'texto'
                    }
                },
                {
                    Header: 'Número Registro',
                    accessor: 'numero_registro',
                    ordenamento: {
                        tipo: 'texto'
                    }
                },
                // {
                //     Header: 'Principal',
                //     accessor: 'principal',
                //     ordenamento: {
                //         tipo: 'texto'
                //     }
                // },
                {
                    Header: 'Data Registro',
                    accessor: 'data_registro',
                    ordenamento: {
                        tipo: 'data'
                    },
                },
                {
                    Header: 'Data Registro Inicial',
                    accessor: 'data_inicial',
                    visivel: false,
                    ordenamento: {
                        tipo: 'data'
                    },
                    filtro: {
                        tipo: 'data_inicial',
                        idColuna: 'data_registro_inicial',
                        datePicker: true,
                        date: true

                    }
                }, {
                    Header: 'Data Registro Final',
                    accessor: 'data_final',
                    visivel: false,
                    ordenamento: {
                        tipo: 'data'
                    },
                    filtro: {
                        tipo: 'data_final',
                        idColuna: 'data_registro_final',
                        datePicker: true,
                        date: true

                    }
                },
            ]
        }], []
    )

    const acoesObj = [
        (propsAcao) => <Visualizar to={'/atendimento/prestadorconselhoprof/visualizacao/' + propsAcao.id} />,
        (propsAcao) => <Alterar to={'/atendimento/prestadorconselhoprof/alteracao/' + propsAcao.row.id} />,
        (propsAcao) => <Excluir to={'atendimento/prestadorconselhoprof/consulta/'} action={() => exclusao(propsAcao)} />,
    ]

    const exclusao = (propsAcao) => {
        const objPermissao = {
            usuario_id: getUsuario().id,
            modulo_id: rProps.modulo,
            acao_id: ACOES.EXCLUIR
        }

        get('/controleAcesso/permissao', objPermissao).then(function (val) {
            if (val.length) {

                excluir('/atendimento/prestadorconselhoprof', propsAcao.row.id,
                    () => {
                        // getApi(setData, '/faturamento/guia')
                        target.current.atualizar();
                        mostrarToast('sucesso', mensagens['sucesso'])
                    },
                    (e) => {
                        if (e.response && e.response.data && e.response.data.erros)
                            e.response.data.erros.forEach((item) => mostrarToast('erro', item))
                        else
                            mostrarToast('erro', mensagens.erro)
                    }, propsAcao.row.descricao_auditoria)
                // get('/atendimento/validaExclusaoCliente', { id: propsAcao.row.id }).then(function (val) {
                //     if (!val.length) {

                //     } else {
                //         mostrarToast('erro', 'Ação não permitida! Cliente ligado a um Movimento ou Lançamento')
                //     }

                // }).catch((e) => mostrarToast('erro', mensagens['erro']))
            } else
                mostrarToast('erro', mensagens['permissao'])

        }).catch((e) => mostrarToast('erro', mensagens['erro']))
    }

    return (
        <>
            <div>
                <DataGridAlternativa target={target} acoesObj={acoesObj} data={data} columns={columns} setData={setData} acoes={true} caminhoBase='/atendimento/prestadorconselhoprof'
                    caminhoConsultaFiltros='/atendimento/prestadorconselhoprofpaginacao' modulo={rProps.modulo} titulo={'Consulta Prestador Conselho Profissional'} tituloLista={'Lista Prestador Conselho Profissional'}
                    urlCadastro='/atendimento/prestadorconselhoprof/cadastro' icone={'icon-Business-ManWoman'} />
            </div>
        </>
    )

}

export default ConsultaCliente